
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'
import { useSearchParams } from "react-router-dom"

export const WaterPressurePreventiveDistributionExportData = (props) => {
    const { ExcelData, name, searchName, RoleID, Date } = props

    const [searchParams] = useSearchParams()
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    // console.log('ExcelData.table.length', ExcelData.table[0].projectName)
    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '49%' }}>

                <h5><span>&emsp;</span></h5>

                <tr>
                    <th colSpan={6} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Navi Mumbai Municipal Corporation</th>
                </tr>
                <tr>
                    <th colSpan={6} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>WATER SUPPLY DEPARTMENT</th>
                </tr>
                {
                    (DashProjectTypeId == '6' && RoleID != '16') ?
                        <tr>
                            <th colSpan={6} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Project Name: - {(ExcelData && ExcelData.table && ExcelData.table[0].projectName) ? (ExcelData && ExcelData.table && ExcelData.table[0].projectName) : '-'}</th>
                        </tr>
                        :
                        <tr>
                            <th colSpan={6} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Project Name: - Main Feeder - Morbe Dam to Digha</th>
                        </tr>
                }

                <tr>
                    <th colSpan={6} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Report Name: {name}</th>
                </tr>

                <tr>
                    {/* <th></th>
                    <th></th> */}
                    <th colSpan={6} style={{ textAlign: 'center', fontSize: 16, border: "1px solid black" }}>Date:- {Date ? moment(Date).format('DD-MM-YYYY') : ''} </th>
                </tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black" }}>
                        <th className="sr_no_col" style={{ borderLeft: "1px solid black" }}>Sr No.</th>
                        <th>Reading Date</th>
                        <th>Time</th>
                        <th>Ward Name</th>
                        {
                            (DashProjectTypeId == '6' && RoleID != '16') ?
                                <th>Location</th>
                                :
                                <th>Junction</th>
                        }
                        <th>Pipe Line (mm)</th>
                        <th style={{ borderRight: "1px solid black" }}>Pressure Value</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => {
                            return (
                                <tr style={{ width: "100%", border: "1px solid black" }}>
                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item?.readingDate ? moment(item?.readingDate).format('DD-MM-YYYY') : ''}</td>
                                    <td style={{ textAlign: "right" }}>{item.readingTime ? item.readingTime : '-'}</td>
                                    <td>{item.wardName ? item.wardName : '-'}</td>
                                    {
                                        (DashProjectTypeId == '6' && RoleID != '16') ?
                                            <td>{item.locationDetails ? item.locationDetails : '-'}</td>
                                            :
                                            <td>{item.junctionDetails ? item.junctionDetails : '-'}</td>
                                    }
                                    <td>{item.pipelineDetails ? item.pipelineDetails : '-'}</td>
                                    <td style={{ width: '10%', textAlign: "right" }}>{item.pressure ? item.pressure : '0.00'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>

            </table>
        </div>
    )
}